import { Address, zeroAddress } from 'viem';

export type PaymentToken = {
  chainId: number;
  address: Address;
  symbol: string;
  decimals: number;
  name?: string;
};

export const chainPaymentTokensMap = {
  // Beam
  4337: [
    {
      chainId: 4337,
      address: zeroAddress,
      symbol: 'BEAM',
      name: 'BEAM',
      decimals: 18,
    },
    {
      chainId: 4337,
      address: '0xD51BFa777609213A653a2CD067c9A0132a2D316A',
      symbol: 'WBEAM',
      name: 'WBEAM',
      decimals: 18,
    },
  ],

  // Beam Testnet
  13337: [
    {
      chainId: 13337,
      address: zeroAddress,
      symbol: 'BEAM',
      name: 'BEAM',
      decimals: 18,
    },
    {
      chainId: 13337,
      address: '0xf65b6f9c94187276c7d91f4f74134751d248bfea',
      symbol: 'WBEAM',
      name: 'WBEAM',
      decimals: 18,
    },
  ],

  // Immutable zkEVM
  13371: [
    {
      chainId: 13371,
      address: zeroAddress,
      symbol: 'IMX',
      name: 'IMX',
      decimals: 18,
    },
    {
      chainId: 13371,
      address: '0x3A0C2Ba54D6CBd3121F01b96dFd20e99D1696C9D',
      symbol: 'WIMX',
      name: 'WIMX',
      decimals: 18,
    },
  ],

  // Immutable zkEVM Testnet
  13473: [
    {
      chainId: 13473,
      address: zeroAddress,
      symbol: 'IMX',
      name: 'IMX',
      decimals: 18,
    },
    {
      chainId: 13473,
      address: '0x1CcCa691501174B4A623CeDA58cC8f1a76dc3439',
      symbol: 'WIMX',
      name: 'WIMX',
      decimals: 18,
    },
  ],

  // Sophon Mainnet
  50104: [
    {
      chainId: 50104,
      address: '0x0f5450df41ea983f4de1de52dd9246e6142be411',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 50104,
      address: '0x2b1A859dE6A55c553520D7780Bc5805712B128F9',
      symbol: 'WSOPH',
      name: 'WSOPH',
      decimals: 18,
    },
  ],

  // Sophon Testnet
  531050104: [
    {
      chainId: 531050104,
      address: '0x155F5f62Ae114a46aF924FAe3a9b994849076403',
      symbol: 'USDC',
      name: 'USDC',
      decimals: 6,
    },
    {
      chainId: 531050104,
      address: '0x9B7EA63EF5062661570afe548e3AD691D5652527',
      symbol: 'WSOPH',
      name: 'WSOPH',
      decimals: 18,
    },
  ],
} as Record<number, PaymentToken[]>;
